import {StoreItemCategory} from '../../../../../../../shared/entity_datas/StoreEnums'
import {BaseStoreItem} from '../../../../../../../shared/store/BaseStoreItem'
import {SIColorBlack} from '../../../../../../../shared/store/StoreItemList'
import {LobbyImage} from '@colonist/types'
import {clientI18n} from '../../../../../../shared/scripts/ClientI18n'
import {Sound} from '../../../../../../shared/scripts/Sound'
import {createDivIn, createHeaderIn, createImgIn, createLinkIn, createParagraphIn, setElementInnerHTML, setElementOnClick} from '../../../../../../shared/scripts/ui_utils/DomUtils'
import {UIMStorePopupView} from './UIMStorePopupView'
import {TranslationObject} from '@colonist/i18n'
import {ClientUserState} from '../../../../../../shared/scripts/ClientUserState'
import {CA} from '../../../../../../shared/scripts/analytics/Analytics'
import {AnalyticEventCategory, AnalyticEventType, GiftMembershipMethod} from '../../../../../../../shared/entity_datas/EntityDatas'
import {AjaxDataTypes} from '../../../../../../../shared/AjaxDataTypes'

export class UIMStoreItemView {
    private readonly itemDiv: HTMLDivElement
    private readonly bodyDiv: HTMLDivElement
    readonly itemDetail: BaseStoreItem
    private readonly storeItemImg: HTMLImageElement
    private readonly storeItemDescription: HTMLParagraphElement
    private readonly storeItemText: HTMLLinkElement
    private readonly button: HTMLLinkElement
    private readonly storeButtonPrice: HTMLParagraphElement
    isMarkedOwned: boolean = false

    constructor(container: HTMLElement, itemDetail: BaseStoreItem, giftAction: () => void, action: () => void) {
        this.itemDetail = itemDetail
        this.itemDiv = createDivIn(container, 'store_page_item', '')

        const headerDiv = createDivIn(this.itemDiv, 'store_page_item_header')
        this.bodyDiv = createDivIn(this.itemDiv, 'store_page_item_body')
        this.button = createLinkIn(this.itemDiv, '#', {key: 'strings:colonistCommon.utils.emptyString'}, 'store_button')

        if(itemDetail.text != undefined) {
            this.button.style.display = 'none'
            this.storeItemText = createLinkIn(this.itemDiv, '', itemDetail.text, 'store_text', '')
            const sendGiftToUnlockClickEventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ABTestClickAnalytics,
                category: AnalyticEventCategory.GiftMembershipOverlay,
                floatValue: GiftMembershipMethod.GifterAvatar,
            }
            setElementOnClick(this.storeItemText, () => {
                if(itemDetail.image != LobbyImage.IconGifter) return
                void CA.sendAnalyticEvent(sendGiftToUnlockClickEventData)
                giftAction()
            }, true, true)
        }

        if(itemDetail.bannerText != undefined) {
            const bannerDiv = createDivIn(this.itemDiv, 'store-page-product-banner')
            const banner = createParagraphIn(bannerDiv, itemDetail.bannerText, '')
        }

        const title = createHeaderIn(headerDiv, itemDetail.name, '', '', 'H3')

        this.storeItemImg = createImgIn(this.bodyDiv, itemDetail.image)

        const forceSubscription = ClientUserState.userState?.forceSubscription ?? true
        const isBlackColor = itemDetail.name.key == new SIColorBlack().name.key

        if(forceSubscription && !isBlackColor) {
            if(itemDetail.category == StoreItemCategory.Expansion || itemDetail.category == StoreItemCategory.Map) {
                createImgIn(this.button, LobbyImage.StoreMembershipPremium, 'store_button_price_icon')
                this.storeButtonPrice = createParagraphIn(this.button, {key: 'strings:storePage.sections.membership.action.subscribe'}, '', '')
            } else if(itemDetail.category == StoreItemCategory.Color) {
                createImgIn(this.button, LobbyImage.StoreMembershipElite, 'store_button_price_icon')
                this.storeButtonPrice = createParagraphIn(this.button, {key: 'strings:storePage.sections.membership.action.subscribe'}, '', '')
            } else {
                createImgIn(this.button, LobbyImage.ColonistCoin, 'store_button_price_icon')
                const priceText: TranslationObject = itemDetail.price == 0 ? {key: 'strings:storePage.FREE'} : {key: 'strings:colonistCommon.utils.#buffer', options: {value: itemDetail.price}}
                this.storeButtonPrice = createParagraphIn(this.button, priceText, '', '')
            }
        } else {
            createImgIn(this.button, LobbyImage.ColonistCoin, 'store_button_price_icon')
            const priceText: TranslationObject = itemDetail.price == 0 ? {key: 'strings:storePage.FREE'} : {key: 'strings:colonistCommon.utils.#buffer', options: {value: itemDetail.price}}
            this.storeButtonPrice = createParagraphIn(this.button, priceText, '', '')
        }

        /* 19 April 2022 Alex Coleman: keeping this logic for SALE items
        if(itemDetail.salePrice != undefined) {
            const percentDiscount = (itemDetail.price - itemDetail.salePrice) / itemDetail.price * 100
            const bannerText = Math.round(percentDiscount) + '% OFF'
            const banner = createDivIn(headerDiv, 'store_item_sale_banner')
            createHeaderIn(banner, bannerText, '', '', 'H4')

            createSpanIn(this.button, 'btn_strike', String(itemDetail.price))
            createSpanIn(this.button, '', String(itemDetail.salePrice))
        }
        */
        this.updateAction(action)
        this.addClickAction()
    }

    addClickAction() {
        setElementOnClick(this.bodyDiv, () => {
            const description = this.itemDetail.description == undefined ? '' : clientI18n.tArray(this.itemDetail.description).join('')
            new UIMStorePopupView(this.itemDetail.name, this.itemDetail.image, {key: 'strings:colonistCommon.utils.#buffer', options: {value: description}})
        })
    }

    updateAction(action: () => void) {
        setElementOnClick(this.button, () => {
            Sound.playSound(Sound.SoundType.Click)
            action()
        })
    }

    markAsSubscribed() {
        setElementInnerHTML(this.storeButtonPrice, {key: 'strings:storePage.sections.membership.subscribed'})
        createImgIn(this.button, LobbyImage.CheckMark)
        this.itemDiv.className = 'store_page_item item_owned'
        this.isMarkedOwned = true
        setElementOnClick(this.button, () => undefined)
    }

    markAsOwned() {
        if(this.button.style.display == 'none') this.button.style.display = 'flex'
        if(this.storeItemText != undefined) this.storeItemText.style.display = 'none'
        setElementInnerHTML(this.storeButtonPrice, {key: 'strings:roomPage.owned', options: {context: 'capitalized'}})
        createImgIn(this.button, LobbyImage.CheckMark)
        this.itemDiv.className = 'store_page_item item_owned'
        this.isMarkedOwned = true
        setElementOnClick(this.button, () => undefined)
    }

    makePrice0() {
        setElementInnerHTML(this.storeButtonPrice, {key: 'strings:colonistCommon.utils.#buffer', options: {value: 0}})
    }

    remove() {
        if(this.itemDiv.parentElement == undefined) return
        this.itemDiv.parentElement.removeChild(this.itemDiv)
    }
}
